/** This file should be overriden for each framework. Ideally this would be implemented in Mitosis.  */
export const TARGET = 'svelte';
